import styled from 'styled-components'

export const Container = styled.div`
  align-items: center;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  margin: 80px 0;
  min-height: calc(100vh - 262px);
  width: 100%;
`

export const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 2rem 0 0;
  width: 100%;
  max-width: 400px;

  @media (min-width: 768px) {
    max-width: 500px;
  }
`

export const Title = styled.h1`
  font-family: Mulish;
  font-style: normal;
  font-weight: bold;
  font-size: 36px;
  color: #151515;
  mix-blend-mode: normal;
  text-align: center;
`

export const Description = styled.p`
  font-family: Mulish;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 32px;
  text-align: center;
  color: #7d7987;
  mix-blend-mode: normal;
`
